import React, { useState } from 'react';

const faqData = [
    {
        question: 'सदस्यों को कैसे ऐड करे ?',
        answer:
            'सम्बंधित परिवार पर टच कर “जोड़े” विकल्प पर टच करे , रिश्तो का चयन कर सदस्य की वांछित जानकारी भर “जोड़े” पर टच करने पर सदस्य उस परिवार में जुड़ जायेगा |',
    },
    {
        question: 'सदस्य का नाम कैसे एडिट करे ?',
        answer:
            'सम्बंधित सदस्य पर टच कर निचे दिए गये विकल्प में से “देखे /बदले” विकल्प पर टच करने पर जानकारी बदलने का विकल्प आ जायेगा | तथा नयी जानकारी जोड़ने के लिए “देखे बदले” विकल्प पर टच करने के बाद निचे “+” के चिन्ह पर टच करने पर आप सम्बंधित नयी जानकारी को जोड़ / अपडेट कर सकते हो |',
    },
    {
        question: 'गलत नाम को कैसे हटाये ?',
        answer:
            'जिन सदस्य का नाम भूलवश/गलती से किसी अन्य परिवार में जुड़ गया है उनका नाम केवल एडमिन द्वारा ही हटाया जायेगा | जिसकी सुचना स्क्रीनशॉट के जरिये आप एडमिन को सूचित करे |',
    },
    {
        question: 'किसी सदस्य की जानकारी कैसे प्राप्त करे ?',
        answer:
            'इसके दो विकल्प है प्रथम आप ऐप्प खुलते ही सबसे ऊपर होम बटन के पास “खोज” के icon पर टच करे सम्बंधित सदस्य का नाम / गाँव / गौत्र की सहायता से किसी भी सदस्य की पूर्ण जानकारी खोज सकते हो | दूसरा विकल्प में विकल्प सूची में से गाँव सूची पर टच कर आप सम्बंधित सदस्य के गांव का चयन करने पर गाँव वासियों की सूची में से जानकारी प्राप्त कर सकते हो |',
    },
];

const FAQ = () => {
    const [activeIndex, setActiveIndex] = useState(null);

    const toggleFAQ = (index) => {
        setActiveIndex(activeIndex === index ? null : index);
    };

    return (
        <div className="bg-gray-300 p-6 rounded-md shadow-md">
            {/* <h2 className="text-2xl font-bold text-blue-800 text-center mb-4">
        FAQ
      </h2> */}
            <div className="text-center text-white mb-12">
                <h2 className="text-4xl text-blue-900 font-bold">FAQ</h2>
                <div className="flex justify-center items-center mt-2">
                    <div className="w-8 h-[2px] bg-blue-950"></div> {/* Line */}
                    <div className="w-2 h-2 bg-blue-950 rounded-full mx-2"></div> {/* Dot */}
                    <div className="w-8 h-[2px] bg-blue-950"></div> {/* Line */}
                </div>

            </div>
            <div className="space-y-4">
                {faqData.map((item, index) => (
                    <div
                        key={index}
                    >
                        <button
                            className={`flex justify-between border-gray-4 shadow-md items-center w-full px-4 py-2 text-lg font-semibold text-gray-700 hover:text-blue-800 text${activeIndex === index && '-blue-800'} focus:outline-none`}
                            onClick={() => toggleFAQ(index)}
                        >
                            <span>{item.question}</span>
                            <span>{activeIndex === index ? '−' : '+'}</span>
                        </button>
                        {activeIndex === index && (
                            <div className="px-4 py-3 bg-gray-350 text-gray-800">
                                {item.answer}
                            </div>
                        )}
                    </div>
                ))}
            </div>
        </div>
    );
};

export default FAQ;
